module.exports = __webpack_public_path__ + "img/no_results_Illustration.e73451e4.png";